import { render } from "./MediumSection.vue?vue&type=template&id=022c4496&scoped=true"
import script from "./MediumSection.vue?vue&type=script&lang=js"
export * from "./MediumSection.vue?vue&type=script&lang=js"

import "./MediumSection.vue?vue&type=style&index=0&id=022c4496&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022c4496"]])

export default __exports__